<template>
	<div class="page-container" :class="{ 'mobile': isMobile }" :style="{ 
	    fontSize: isMobile ? '16px' : '16px',
	  }">
		<!-- 导航栏 -->
		<nav class="advisor-nav">
			<div class="nav-content">
				<span class="logo">时尚AI顾问</span>
			</div>
		</nav>
		<main class="content" ref="messageListRef" :style="{ 
				padding: isMobile ? '16px' : '20px'
			}">
			<div class="greeting-section">
				<span class="greeting-title">Hi~我是时尚AI顾问</span>
				<p class="greeting-text">
					<span class="text-line">你身边的智能助手，可以为你答疑解惑，快来体验一下吧~</span>
				</p>
			</div>
			<!-- 聊天消息列表（可滚动区域） -->
			<div class="message-item" v-for="message in messagesList1" :key="message.id"
				:class="{ 'from-me': message.from === 'user' }">
				<div class="stage"
					v-if="message.from === 'ai' && message.status != 'finish' && isSending && !isResponsing">
					<div class="dot-flashing"></div>
				</div>
				<div v-if="message.from === 'ai' && (isResponsing || message.isThinkEnd)">
					<div style="color: #666666;">
						{{ message.thinkStatus }}
					</div>
					<br />
				</div>
				<div v-if="message.from === 'ai'">
					<div class="think-txt" v-html="message.thinkTxt"></div>
					<!-- <br /> -->
				</div>
				<div v-html="message.content"></div>
			</div>
		</main>
		<!-- 添加悬浮按钮 -->
		<button v-if="showBottomButton" class="floating-button-bottom-center" @click="scrollToBottom">
			<img src="@/assets/icon-bottom.png" alt="图标" class="button-icon">
		</button>
		<footer class="chat-input">
			<div class="input-area">
				<input class="no-outline" v-model="inputMessage" @keyup.enter="sendMessage" placeholder="给时尚AI发信息" />
				<!-- <button @click="sendMessage">发送</button> -->
			</div>
		</footer>

	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		onBeforeUnmount,
		nextTick
	} from 'vue'

	import {
		v4 as uuidv4
	} from 'uuid'

	let inputMessage = ref();
	let messagesList1 = ref([]);
	let messagesList2 = ref([]);
	let isMobile = ref(false);
	let isSending = ref(false);
	let isResponsing = ref(false);

	const checkDevice = () => {
		const ua = navigator.userAgent
		isMobile.value =
			/Mobile|Android|iPhone/i.test(ua) || window.innerWidth < 768
	}

	const extractTextResponse = (rawString) => {
		try {
			let jsonString = rawString.replace('data:', '');
			// 查找 "textResponse": 的位置
			let textResponseKeyIndex = jsonString.indexOf('"textResponse":');

			if (textResponseKeyIndex !== -1) {
				// 找到 "textResponse": 后的第一个引号
				let firstQuoteIndex = jsonString.indexOf('"', textResponseKeyIndex + '"textResponse":'.length);

				// 找到第二个引号
				let secondQuoteIndex = jsonString.indexOf('"', firstQuoteIndex + 1);

				// 提取 textResponse 的值
				let textResponse = jsonString.substring(firstQuoteIndex + 1, secondQuoteIndex);

				return textResponse;
			} else {
				// console.log("未找到 textResponse");
				return "";
			}
		} catch (error) {
			// console.error("解析字符串失败:", error);
			//return "解析失败";
			return "";
		}
	}

	const processMessageText = (text) => {
		let unescaped = text.replace(/\\n/g, '\n')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
		let txt = unescaped.replace(/\n\n/g, '<br />');
		return txt.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
	}

	// 定义消息列表容器的 ref
	const messageListRef = ref(null);
	// 定义一个 ResizeObserver 实例
	const resizeObserver = ref(null);
	// 定义一个响应式变量来控制按钮的显示状态
	const showBottomButton = ref(false);

	const handleScroll = () => {
		if (messageListRef.value) {
			const {
				scrollTop,
				scrollHeight,
				clientHeight
			} = messageListRef.value;
			// 判断是否滚动到底部
			showBottomButton.value = scrollTop + clientHeight < scrollHeight;
		}
	};

	onMounted(() => {
		checkDevice()
		window.addEventListener('resize', checkDevice)
		if (messageListRef.value) {
			messageListRef.value.addEventListener('scroll', handleScroll);
		}
		// 创建 ResizeObserver 实例
		resizeObserver.value = new ResizeObserver(() => {
			handleScroll(); // 调用 handleScroll 函数检查是否滚动到底部
		});

		// 开始观察 messageListRef 的大小变化
		resizeObserver.value.observe(messageListRef.value);
	});

	onBeforeUnmount(() => {
		window.removeEventListener('resize', checkDevice)
		if (messageListRef.value) {
			messageListRef.value.removeEventListener('scroll', handleScroll);
			// 停止观察 messageListRef 的大小变化
			resizeObserver.value.disconnect();
		}
	});

	const scrollToBottom = () => {
		// 消息发送完成后，滚动到页面底部
		nextTick(() => {
			if (messageListRef.value) {
				messageListRef.value.scrollTop = messageListRef.value.scrollHeight;
			}
		});
	}

	const sendMessage = async () => {
		// 如果正在发送，直接返回
		if (isSending.value || inputMessage.value === '') {
			console.log("empty", isSending.value);
			console.log("empty", inputMessage.value);
			return;
		}
		// 设置为正在发送
		isSending.value = true;

		let message = {
			id: Date.now(),
			from: 'user',
			content: inputMessage.value
		};

		messagesList1.value.push(message);
		let inputValue = inputMessage.value;
		// 清空输入框
		inputMessage.value = '';

		message = {
			id: Date.now(),
			from: 'ai',
			status: 'thinking',
			thinkTxt: '',
			thinkStatus: '深度思考中...',
			isThinkEnd: false,
			content: '',
		};
		messagesList1.value.push(message);
		scrollToBottom();
		try {
			const response = await fetch(
				// 'http://192.168.5.30:3001/api/v1/workspace/fashion/stream-chat', {
				'https://aichat-any.gongligz.com/api/v1/workspace/fashion/stream-chat', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer AGQX0MZ-63445QA-N9N55R3-A5R78C6',
						'Accept': '*/*',
						// 'Host': '192.168.5.30:3001',
						'Connection': 'keep-alive'
					},
					body: JSON.stringify({
						message: inputValue,
						sessionId: uuidv4(),
						mode: 'chat'
					})
				}
			);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const reader = response.body.getReader();
			const decoder = new TextDecoder();

			while (true) {
				const {
					done,
					value
				} = await reader.read();
				if (done) break;

				const chunk = decoder.decode(value, {
					stream: true
				});
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"<think>","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"\n","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"好","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"<think />","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"\n\n","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"你好","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"！","close":false,"error":false}'
				// let chunk = 'data: {"uuid":"6dbeaba2-03d3-42ba-a370-f1bc2e60641f","sources":[],"type":"textResponseChunk","textResponse":"欢迎","close":false,"error":false}'
				// ...
				// 获取 textResponse
				let textResponse = extractTextResponse(chunk);

				// 判断 textResponse 是否包含 </think>
				let msg = messagesList1.value.pop();
				if (!msg.isThinkEnd) {
					msg.isThinkEnd = textResponse.includes('</think>');
					console.log('msg.isThinkEnd: ', msg.isThinkEnd);
				}

				const processedText = processMessageText(textResponse.replace(/<\/?think>/g, ''));

				if (!msg.isThinkEnd) {
					msg.thinkTxt += processedText;
					console.log("msg.thinkTxt:::" + msg.thinkTxt);
				} else {
					msg.content += processedText;
					console.log("msg.content:::" + msg.content);
				}

				messagesList1.value.push(msg);
				isResponsing.value = true;
			}
			let lastMsg = messagesList1.value.pop();
			lastMsg.thinkStatus = "已深度思考";
			lastMsg.status = "finish";
			messagesList1.value.push(lastMsg);
		} catch (error) {
			console.error('请求失败:', error);
			// 处理请求失败的情况
		} finally {
			isSending.value = false;
			isResponsing.value = false;
			// 滚动到最底部
			scrollToBottom();
		}
	}
</script>

<style>
	.page-container {
		display: flex;
		flex-direction: column;
		height: 100vh;
		/* 或 100dvh 解决移动端问题 */
	}

	.content {
		display: flex;
		/* 占据剩余空间 */
		overflow-y: auto;
		/* 允许消息滚动 */
		flex-direction: column;
		flex-grow: 1;
	}

	/* 导航样式 */
	.advisor-nav {
		background: #ffffff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.nav-content {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 2.75rem;
		margin: 0 auto;
		text-align: center;
	}

	.logo {
		color: #222222;
		font-size: 1rem;
		font-weight: 500;
	}

	/* 内容区域 */
	.content-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: calc(100vh - 72px);
	}

	.content-box {
		background: white;
		max-width: 600px;
		text-align: center;
	}

	/* 文字样式 */
	.greeting-title {
		color: #2c3e50;
		font-size: 1.25rem;
	}

	.greeting-text {
		color: #666;
		font-size: 1.1rem;
	}

	.text-line {
		display: block;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.content-box {}

		.greeting-title {
			font-weight: 500;
			font-size: 1.25rem;
		}

		.greeting-text {
			font-size: 1rem;
		}
	}

	/* 底部居中悬浮按钮样式 */
	.floating-button-bottom-center {
		position: fixed;
		bottom: 78px;
		/* 距离底部的距离 */
		left: 50%;
		/* 先将按钮左边缘置于容器中心 */
		transform: translateX(-50%);
		/* 再将按钮向左移动自身宽度的一半，实现居中 */
		width: 2.5rem;
		height: 2.5rem;
		background-color: white;
		/* 按钮背景颜色 */
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
		border: none;
		border-radius: 2rem;
		cursor: pointer;
		z-index: 100;
		/* 确保按钮显示在其他元素之上 */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/* 按钮内图标的样式 */
	.button-icon {
		width: 1.5rem;
		/* 图标宽度 */
		height: 1.5rem;
		/* 图标高度 */
		object-fit: contain;
		/* 保持图标比例 */
	}

	.chat-input {
		height: auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.input-area {
		display: flex;
		margin: 10px;
		background: #F6F7FB;
		border-radius: 50px;
		width: 100%;
	}

	input {
		flex: 1;
		padding: 14px 16px;
		background: transparent;
		border: 0;
		font-size: 1rem;
	}

	/* 修改 placeholder 颜色 */
	input::placeholder {
		color: #999;
		/* 浅灰色 */
		opacity: 1;
		font-size: 1rem;
		/* 确保颜色不透明（某些浏览器默认半透明） */
	}

	/* 方案B：替换为更柔和的样式（推荐可访问性） */
	.no-outline:focus {
		outline: none;
	}

	.message-list {
		display: flex;
		flex-grow: 1;
		overflow-y: auto;
		flex-direction: column;
		margin: 10px;
		border-radius: 8px;
		height: 100%;
	}

	.message-item {
		border-radius: 16px;
		max-width: 80%;
		word-wrap: break-word;
		text-align: start;
		display: inline-block;
	}

	.think-txt {
		color: #999999;
		border-left: 2px solid #dddddd;
		padding-left: 12px;
	}

	.from-me {
		align-self: flex-end;
		background: #F6F7FB;
		color: #000000;
		text-align: end;
		align-items: flex-end;
		padding: 0.625rem 1rem;
		margin: 8px 0px;
		border-radius: 50px;
		display: flex;
		align-items: center;
	}

	button {
		padding: 10px 15px;
		background: #42b983;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}

	.mobile {
		font-size: 14px;
	}

	.stage {
		display: flex;
		justify-content: center;
		align-items: center;
		justify-content: flex-start;
		margin-left: 12px;
	}

	.dot-flashing {
		position: relative;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		background-color: #8a8a8a;
		color: #8a8a8a;
		animation: dotFlashing 1s infinite linear alternate;
		animation-delay: 0.5s;
	}

	.dot-flashing::before {
		left: -15px;
		animation: dotFlashing 1s infinite alternate;
		animation-delay: 0s;
	}

	.dot-flashing::after {
		left: 15px;
		animation: dotFlashing 1s infinite alternate;
		animation-delay: 1s;
	}

	.dot-flashing::before,
	.dot-flashing::after {
		content: "";
		display: inline-block;
		position: absolute;
		top: 0;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		background-color: #8a8a8a;
		color: #8a8a8a;
	}

	@keyframes dotFlashing {
		0% {
			background-color: #8a8a8a;
		}

		100% {
			background-color: #d4d4d4;
		}
	}
</style>